/**
 * One row of filters for a list, each with how many it holds. The count is
 * quiet unless the filter holds something the office must check (`alert`),
 * so a red badge always means "look at this".
 */
export function FilterChips(props: {
  label: string;
  chips: { key: string; label: string; count?: number; alert?: boolean }[];
  current: string;
  onPick(key: string): void;
}) {
  return (
    <div className="chips filter-chips" role="group" aria-label={props.label}>
      {props.chips.map((c) => (
        <button
          key={c.key || 'all'}
          type="button"
          className={props.current === c.key ? 'chip on' : 'chip'}
          aria-pressed={props.current === c.key}
          onClick={() => props.onPick(c.key)}
        >
          {c.label}
          {c.count !== undefined && (
            <span className={c.alert && c.count > 0 ? 'count' : 'count quiet'}>{c.count}</span>
          )}
        </button>
      ))}
    </div>
  );
}
